/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  CardBase,
  CardBaseContent,
  FlexContainer,
  GridContainer,
  Label,
  TabsHorizontal,
  setColorTheme,
} from '@facephi/ui-react';
import styled from 'styled-components';

export const StyledTabs = styled(TabsHorizontal)`
  width: 100%;

  > [role='tabpanel'] {
    background-color: transparent;
    padding: 0;
  }
`;

export const StyledListElement = styled(FlexContainer)`
  min-height: 3.8rem;
  padding: 0.8rem;
  border-bottom: 1px solid ${setColorTheme('grey200')};
`;

export const StyledHeader = styled(FlexContainer)<{ $paddingSmall?: boolean }>`
  background-color: ${setColorTheme('white')};
  padding: ${(props) => (props.$paddingSmall ? '1.6rem' : '2.4rem')};
  height: 6.4rem;
  border-radius: 1.2rem;
`;

export const StyledTableGrid = styled(FlexContainer)`
  grid-column-end: -1;
  grid-column-start: 1;
`;

export const StyledPrivacyTab = styled(FlexContainer)`
  height: 100%;
`;

export const WIDTH_CREDENTIALS_CARD = '44rem';

export const StyledCredentialsCard = styled(CardBase)`
  width: ${WIDTH_CREDENTIALS_CARD};
  height: 100%;

  ${CardBaseContent} {
    overflow-y: auto;
    height: 100%;
    flex: 1 1 0;
  }
` as any;

export const StyledQrLabel = styled(Label)`
  margin-top: 0.8rem;
  margin-left: 0.8rem;
` as any;

export const StyledCardOverflow = styled(CardBaseContent)`
  overflow: auto;

  > ul {
    overflow: auto;
    margin-right: -2.4rem;
    padding-right: 2.4rem;
  }
`;

export const StyledCustomTabs = styled(FlexContainer)`
  height: 100%;
`;

export const StyledGridCustomer = styled(GridContainer)`
  flex: 1;
`;

export const RowContainerGrid = styled(GridContainer)`
  text-align: left;
  padding: 0 0rem 3.2rem 0rem !important;
`;

export const CellContainer = styled(FlexContainer)`
  flex-direction: column;
  border-bottom: 0.1rem solid rgba(204, 212, 229, 1);
  padding: 1.6rem 1.2rem;
  &:last-of-type {
    flex: 1 0 calc(100% / 3);
  }
`;

export const CardContainer = styled.div`
  padding: 0 0rem 3.2rem 0rem !important;
`;

export const OperationsEmptyDataStyles = styled(FlexContainer)`
  padding: 6rem;
  background: ${setColorTheme('white')};
  border-radius: 0.8rem;
`;
